<template>
 <div>
 <div class="card mb-3">
  <img class="card-img-top" src="img/about-us-banner.png" alt="Card image cap">
  <div class="card-body">
    <h4 class="card-title">About Us</h4>
    <h5 class="card-text">VISI</h5>
<p class="card-text">Menjadi perusahaan yang mempunyai reputasi tinggi di kawasan Asia Tenggara dengan aspek profitabilitas, penjualan dan kepuasan konsumen melalui karya yang kreatif dan inovatif dari seluruh karyawan yang kompeten.
</p><br>

<h5 class="card-text">MISI</h5>
<ul>
    <li>Secara berkesinambungan menyediakan produk dan jasa yang berkualitas tinggi serta memenuhi kebutuhan pelanggan melalui program pemasaran yang terbaik.
</li>
    <li>Mengembangkan karyawan yang berkompeten dengan menciptakan lingkungan kerja yang baik untuk mendukung tercapainya kepuasan pelanggan.

    </li>
    <li>Memperkuat kolaborasi dengan produsen, dealer utama dan dealer-dealer melalui komunikasi dan kerjasama yang lebih baik.
</li>
    <li>Untuk mengembangkan operasi perusahaan yang sehat dalam segala aspek, misalnya pemenuhan peraturan, lingkungan dan lain-lain.</li>
</ul>

    </div>
</div>

   
  </div>
</template>

<script>

export default {
  name: 'home',
  components: {
  
  }
 
    
     
  
}
</script>

<style>


  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  .hvrbox,
.hvrbox * {
	box-sizing: border-box;
}
.hvrbox {
	position: relative;
	display: inline-block;
	overflow: hidden;
	max-width: 100%;
	height: auto;
}
.hvrbox img {
	max-width: 100%;
}
.hvrbox .hvrbox-layer_bottom {
	display: block;
}
.hvrbox .hvrbox-layer_top {
	opacity: 0;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.6);
	color: #fff;
	padding: 0px;
	-moz-transition: all 0.4s ease-in-out 0s;
	-webkit-transition: all 0.4s ease-in-out 0s;
	-ms-transition: all 0.4s ease-in-out 0s;
	transition: all 0.4s ease-in-out 0s;
}
.hvrbox:hover .hvrbox-layer_top,
.hvrbox.active .hvrbox-layer_top {
	opacity: 1;
}
.hvrbox .hvrbox-text {
	text-align: center;
	font-size: 14px;
	display: inline-block;
	position: absolute;
	top: 50%;
	left: 50%;
	-moz-transform: translate(-50%, -50%);
	-webkit-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
}
.hvrbox .hvrbox-text_mobile {
	font-size: 15px;
	border-top: 1px solid rgb(179, 179, 179); /* for old browsers */
	border-top: 1px solid rgba(179, 179, 179, 0.7);
	margin-top: 5px;
	padding-top: 2px;
	display: none;
}
.hvrbox.active .hvrbox-text_mobile {
	display: block;
}
</style>
